import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCloseButton from 'components/common/FalconCloseButton';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { firstPageContents as contents, stages } from './homeData';
import ConfirmationModal from './home-modals/ConfirmationModal';
import PropTypes from 'prop-types';
import {
  amountsOptions,
  countryOptions,
  donationCurrencyData,
  donationOptions
} from './homeData';

const Page1 = ({ setStage, showContent, setShowContent }) => {
  const [show, setShow] = useState(false);
  const [country, setCountry] = useState('');
  const [showDonationTypeInfo, setShowDonationTypeInfo] = useState(true);
  const [donationType, setDonationType] = useState([1, 2]);
  const [donationCurrency, setDonationCurrency] = useState({
    value: '1',
    label: 'USD',
    symbol: '$'
  });

  const donationTypeHandler = id => {
    const preDonationType = [...donationType];
    const findIndexOfDonationType = preDonationType.indexOf(id);

    if (findIndexOfDonationType === -1) {
      preDonationType.push(id);
    } else {
      preDonationType.splice(findIndexOfDonationType, 1);
    }

    setDonationType(preDonationType);
  };

  return (
    <>
      {showContent === contents.donationType && (
        <>
          <Card className="mb-4 we-card-shadow">
            <Card.Header className="p-4">
              <Card.Title className="mb-0">Donation Type </Card.Title>
            </Card.Header>
            <Card.Body className="p-4 pt-0">
              <Row className="g-3">
                <Col md={6}>
                  <Button
                    variant="falcon-default"
                    className="w-100 p-3 bg-100 hover-border-primary hover-bg-primary hover-100"
                    size="lg"
                    onClick={() => setShowDonationTypeInfo(true)}
                  >
                    Monthly Donation
                  </Button>
                </Col>
                <Col md={6}>
                  <IconButton
                    iconAlign="right"
                    icon={'check-square'}
                    iconClassName="ms-2"
                    className="w-100  p-3"
                    size="lg"
                    onClick={() => setShowDonationTypeInfo(true)}
                  >
                    One-OFF Donation
                  </IconButton>
                </Col>
              </Row>
              {showDonationTypeInfo && (
                <div className="border rounded-3 border-primary bg-100 p-3 mt-4">
                  <Flex justifyContent="between" alignItems="middle">
                    <p className="mb-0 fs-0 fw-medium">
                      Become a monthly supporter
                    </p>
                    <FalconCloseButton
                      size="sm"
                      onClick={() => setShowDonationTypeInfo(false)}
                    />
                  </Flex>
                  <div className="mt-3">
                    <p>
                      Will you consider becoming one of our Valued Monthly
                      supporters by converting your $50 Contribution into a
                      monthly donation?
                    </p>
                    <p>
                      Ongoing monthly donations allow us to better focus on our
                      mission.
                    </p>
                  </div>
                  <Flex className="flex-column flex-md-row">
                    <IconButton
                      className="fs--1 fw-medium rounded-pill me-md-3 py-2"
                      variant="primary"
                      icon="hand-holding-heart"
                      transform="shrink-3"
                    >
                      Donate $10/Month
                    </IconButton>
                    <Button
                      variant="falcon-default"
                      className="fs--1 fw-medium rounded-pill border-200 mt-3 mt-md-0 bg-200 hover-bg-primary hover-border-primary hover-100 py-2"
                    >
                      No thanks, Keep it as one time gift
                    </Button>
                  </Flex>
                </div>
              )}
            </Card.Body>
          </Card>
          <Flex justifyContent="end" alignItems="center">
            <Button
              className="h-52 w-215px mt-3 mt-md-0"
              onClick={() => setShowContent(contents.donationCause)}
            >
              Next
            </Button>
          </Flex>
        </>
      )}
      {showContent === contents.donationCause && (
        <>
          <Card className="mb-4 we-card-shadow">
            <Card.Header className="p-4">
              <Card.Title className="mb-0">Select Your Cause</Card.Title>
            </Card.Header>
            <Card.Body className="p-4 pt-0">
              <Form.Group as={Col} md={12} className="position-relative mb-3">
                <small className="wr-custom-label">Country</small>
                <ReactSelect
                  closeMenuOnSelect={true}
                  options={countryOptions}
                  placeholder="Select"
                  classNamePrefix="react-select"
                  className="wr-donation-amount-currency"
                  value={country}
                  onChange={value => setCountry(value)}
                  menuPosition="fixed"
                />

                <Form.Control.Feedback type="invalid">
                  Required
                </Form.Control.Feedback>
              </Form.Group>
              <Row className="g-3">
                {donationOptions?.map(item => (
                  <Col key={item.id} md={6}>
                    <Button
                      variant="outline-secondary"
                      size="lg"
                      className={`${
                        donationType?.includes(item.id) && 'active'
                      } wr-custom-donation-btn w-100 p-2`}
                      onClick={() => donationTypeHandler(item.id)}
                    >
                      {item.title}
                    </Button>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
          <Flex
            justifyContent="between"
            alignItems="center"
            className={'mt-3 flex-column flex-md-row'}
          >
            <Button
              variant="default"
              className="bg-soft-secondary h-52 hover-bg-primary hover-100 w-215px"
              onClick={() => setShowContent(contents.donationType)}
            >
              Back
            </Button>
            <Button
              className="h-52 w-215px mt-3 mt-md-0"
              onClick={() => setShowContent(contents.donationAmount)}
            >
              Next
            </Button>
          </Flex>
        </>
      )}

      {showContent === contents.donationAmount && (
        <>
          <Card className="mb-4 we-card-shadow">
            <Card.Header className="p-4">
              <Card.Title className="mb-0">Donation Amount</Card.Title>
            </Card.Header>
            <Card.Body className="p-4 pt-0 pb-2">
              <Row className="g-3 d-flex align-items-end mb-3">
                <Form.Group as={Col} md={3}>
                  <Form.Label>Currency</Form.Label>
                  <ReactSelect
                    closeMenuOnSelect={true}
                    options={donationCurrencyData}
                    placeholder="Select"
                    classNamePrefix="react-select"
                    className="wr-donation-amount-currency"
                    value={donationCurrency}
                    onChange={value => setDonationCurrency(value)}
                    menuPosition="fixed"
                  />
                  <Form.Control.Feedback type="invalid">
                    Required
                  </Form.Control.Feedback>
                </Form.Group>

                <Col md={9}>
                  <Row className="g-3">
                    {amountsOptions?.map(amount => (
                      <Col key={amount.id} md={3}>
                        <Button
                          variant="falcon-default"
                          className={`${
                            amount.id === 50 && 'active'
                          } wr-donation-amount border-0 shadow-sm w-100`}
                        >
                          {amount.id !== 'other' && donationCurrency?.symbol}
                          {amount.label}
                        </Button>
                      </Col>
                    ))}
                  </Row>
                </Col>
                <Form.Group as={Col} md={6} controlId="Custom Amount">
                  <Form.Control
                    className="h-52"
                    required
                    type="number"
                    placeholder={`Custom Amount (${donationCurrency.symbol})`}
                  />
                  <Form.Control.Feedback type="invalid">
                    Custom Amount
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <p>
                <FontAwesomeIcon
                  icon={'hand-holding-heart'}
                  className="text-primary"
                />{' '}
                Making A donation of
                <strong> £50</strong> will Save one life at least.
              </p>
              <Form.Check
                type="checkbox"
                id="Give_in_honor_or_In_memory"
                label="Give in honor or In memory"
              />
            </Card.Body>
          </Card>
          <Flex
            justifyContent="between"
            alignItems="center"
            className={'mt-3 flex-column flex-md-row'}
          >
            <Button
              variant="default"
              className="bg-soft-secondary h-52 hover-bg-primary hover-100 w-215px"
              onClick={() => setShowContent(contents.donationCause)}
            >
              Back
            </Button>
            <Button
              className="h-52 w-215px mt-3 mt-md-0"
              onClick={() => setShow(true)}
            >
              Continue
            </Button>
          </Flex>
        </>
      )}
      {/* <Button onClick={() => setShow(true)} className="w-100 h-52" size="lg">
        Continue
      </Button> */}

      <ConfirmationModal
        show={show}
        setShow={setShow}
        title="Make another donation?"
        subTitle="Would you like to make another contribution?"
        noBtnText="No, Skip"
        yesBtnText="Yes Donate Again"
        noBtnAction={() => setStage(stages.Donation2)}
        yesBtnAction={() => console.log('yes')}
      />
    </>
  );
};

Page1.propTypes = {
  setStage: PropTypes.func.isRequired,
  showContent: PropTypes.string.isRequired,
  setShowContent: PropTypes.func.isRequired
};

export default Page1;
